import * as t from './actionTypes';
import { fetchPurchasesResponse } from './actions';
import type { PurchasesReduxState } from './types';

type PurchaseReducerAction = ReturnType<typeof fetchPurchasesResponse>;

export const initialPurchasesReducerState: PurchasesReduxState['insights']['purchases'] = {
  purchases: [],
};

const purchasesReducer = (state = initialPurchasesReducerState, action: PurchaseReducerAction) => {
  switch (action.type) {
    case t.FETCH_PURCHASES_RESPONSE: {
      return {
        ...state,
        purchases: action.response,
      };
    }
    default: {
      return state;
    }
  }
};

export default purchasesReducer;
